"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = void 0;
/* eslint-disable prefer-arrow/prefer-arrow-functions */
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
const AE_1 = require("./ae/AE");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Espool_1 = require("./espool/Espool");
const fuehrungsrinne_1 = require("./fuehrungsrinne/fuehrungsrinne");
const montage_set_1 = require("./montageSet/montage-set");
const IA_1 = require("./ia/IA");
const Kette_1 = require("./kette/Kette");
const Konfektionierung_1 = require("./konfektionierung/Konfektionierung");
const Leitung_1 = require("./leitung/Leitung");
const MontBes_1 = require("./montBes/MontBes");
const Karton_1 = require("./verpackung/Karton");
const Palette_1 = require("./verpackung/Palette");
const Trommel_1 = require("./verpackung/Trommel");
const Zubehoer_1 = require("./zubehoer/Zubehoer");
const Zugentlastung_1 = require("./zugentlastung/Zugentlastung");
const Link_1 = require("./link/Link");
const echain_product_models_1 = require("@igus/echain-product-models");
const Ecp_1 = require("./zubehoer/smartPlastics/ecp/Ecp");
const SmartPlastics_1 = require("./zubehoer/smartPlastics/SmartPlastics");
function A(a) {
    if (A.is.ae(a)) {
        return AE_1.AE.fromModel(a);
    }
    if (A.is.espool(a)) {
        return Espool_1.Espool.fromModel(a);
    }
    if (A.is.fuehrungsrinne(a)) {
        return fuehrungsrinne_1.Fuehrungsrinne.fromModel(a);
    }
    if (A.is.ia(a)) {
        return IA_1.IA.fromModel(a);
    }
    if (A.is.kette(a)) {
        return Kette_1.Kette.fromModel(a);
    }
    if (A.is.konfektionierung(a)) {
        return Konfektionierung_1.Konfektionierung.fromModel(a);
    }
    if (A.is.leitung(a)) {
        return Leitung_1.Leitung.fromModel(a);
    }
    if (A.is.link(a)) {
        return Link_1.Link.fromModel(a);
    }
    if (A.is.montBes(a)) {
        return MontBes_1.MontBes.fromModel(a);
    }
    if (A.is.montageSet(a)) {
        return montage_set_1.MontageSet.fromModel(a);
    }
    if (A.is.karton(a)) {
        return Karton_1.Karton.fromModel(a);
    }
    if (A.is.palette(a)) {
        return Palette_1.Palette.fromModel(a);
    }
    if (A.is.trommel(a)) {
        return Trommel_1.Trommel.fromModel(a);
    }
    if (A.is.ecp(a)) {
        return Ecp_1.ECP.fromModel(a);
    }
    if (A.is.zubehoer(a)) {
        return Zubehoer_1.Zubehoer.fromModel(a);
    }
    if (A.is.smartPlastics(a)) {
        return SmartPlastics_1.SmartPlastics.fromModel(a);
    }
    if (A.is.zugentlastung(a)) {
        return Zugentlastung_1.Zugentlastung.fromModel(a);
    }
    (0, echain_shared_logging_1.getLogger)().log(`A(): unknown Article`, { a });
    throw new Error(`A(): unknown Article: ${a.Id}`);
}
exports.A = A;
function optional(a) {
    if (!a) {
        return undefined;
    }
    if (A.is.ae(a)) {
        return AE_1.AE.fromModel(a);
    }
    if (A.is.espool(a)) {
        return Espool_1.Espool.fromModel(a);
    }
    if (A.is.fuehrungsrinne(a)) {
        return fuehrungsrinne_1.Fuehrungsrinne.fromModel(a);
    }
    if (A.is.ia(a)) {
        return IA_1.IA.fromModel(a);
    }
    if (A.is.kette(a)) {
        return Kette_1.Kette.fromModel(a);
    }
    if (A.is.konfektionierung(a)) {
        return Konfektionierung_1.Konfektionierung.fromModel(a);
    }
    if (A.is.leitung(a)) {
        return Leitung_1.Leitung.fromModel(a);
    }
    if (A.is.link(a)) {
        return Link_1.Link.fromModel(a);
    }
    if (A.is.montBes(a)) {
        return MontBes_1.MontBes.fromModel(a);
    }
    if (A.is.montageSet(a)) {
        return montage_set_1.MontageSet.fromModel(a);
    }
    if (A.is.karton(a)) {
        return Karton_1.Karton.fromModel(a);
    }
    if (A.is.palette(a)) {
        return Palette_1.Palette.fromModel(a);
    }
    if (A.is.trommel(a)) {
        return Trommel_1.Trommel.fromModel(a);
    }
    if (A.is.ecp(a)) {
        return Ecp_1.ECP.fromModel(a);
    }
    if (A.is.zubehoer(a)) {
        return Zubehoer_1.Zubehoer.fromModel(a);
    }
    if (A.is.zugentlastung(a)) {
        return Zugentlastung_1.Zugentlastung.fromModel(a);
    }
    (0, echain_shared_logging_1.getLogger)().log(`A.optional(): unknown Article`, { a });
    throw new Error(`A.optional(): unknown Article: ${a.Id}`);
}
A.optional = optional;
// We cannot use a Type here since type guards cannot be described. We let the compiler infer.
A.is = {
    ae: (a) => a.ArticleType === echain_product_models_1.ArticleType.ae,
    espool: (a) => a.ArticleType === echain_product_models_1.ArticleType.espool,
    fuehrungsrinne: (a) => a.ArticleType === echain_product_models_1.ArticleType.fuehrungsrinne,
    ia: (a) => a.ArticleType === echain_product_models_1.ArticleType.ia,
    kette: (a) => a.ArticleType === echain_product_models_1.ArticleType.kette,
    konfektionierung: (a) => a.ArticleType === echain_product_models_1.ArticleType.konfektionierung,
    leitung: (a) => a.ArticleType === echain_product_models_1.ArticleType.leitung,
    link: (a) => a.ArticleType === echain_product_models_1.ArticleType.link,
    montageSet: (a) => a.ArticleType === echain_product_models_1.ArticleType.montageSet,
    montBes: (a) => a.ArticleType === echain_product_models_1.ArticleType.montBes,
    verpackung: (a) => a.ArticleType === echain_product_models_1.ArticleType.verpackung,
    karton: (a) => A.is.verpackung(a) && a.Typ === echain_shared_articles_1.VerpackungType.karton,
    palette: (a) => A.is.verpackung(a) && a.Typ === echain_shared_articles_1.VerpackungType.palette,
    trommel: (a) => A.is.verpackung(a) && a.Typ === echain_shared_articles_1.VerpackungType.trommel,
    zubehoer: (a) => a.ArticleType === echain_product_models_1.ArticleType.zubehoer,
    zugentlastung: (a) => a.ArticleType === echain_product_models_1.ArticleType.zugentlastung,
    ecp: (a) => { var _a, _b; return Boolean(((_a = a.ArticleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.ECPDummy)) || ((_b = a.ArticleSpecs) === null || _b === void 0 ? void 0 : _b.includes(echain_shared_articles_1.ArticleSpecs.ECPSensor))); },
    smartPlastics: (a) => (0, echain_shared_articles_1.isSmartPlasticsModel)(a),
};
A.AE = AE_1.AE;
A.Espool = Espool_1.Espool;
A.Fuehrungsrinne = fuehrungsrinne_1.Fuehrungsrinne;
A.IA = IA_1.IA;
A.Kette = Kette_1.Kette;
A.Konfektionierung = Konfektionierung_1.Konfektionierung;
A.Leitung = Leitung_1.Leitung;
A.Link = Link_1.Link;
A.MontageSet = montage_set_1.MontageSet;
A.MontBes = MontBes_1.MontBes;
A.Karton = Karton_1.Karton;
A.Palette = Palette_1.Palette;
A.Trommel = Trommel_1.Trommel;
A.Zubehoer = Zubehoer_1.Zubehoer;
A.Zugentlastung = Zugentlastung_1.Zugentlastung;
//# sourceMappingURL=A.js.map